
import { defineComponent } from 'vue';
import { AppFormRow, AppFileUpload, AppButton, AppCard } from '@/components';
import { useTransactionExport } from '@/modules/transaction/text/model/export';
import { ROUTE_NAME_TRANSACTION } from '@/modules/transaction/router';

export default defineComponent({
    name: ROUTE_NAME_TRANSACTION.TEXT.EXPORT,
    components: { AppFormRow, AppFileUpload, AppButton, AppCard },
    setup() {
        const { model, exportXml, importXml } = useTransactionExport();

        return { model, exportXml, importXml };
    }
});
